import { Controller } from "@hotwired/stimulus";
import { WishlistIcon } from "../components";
import { checkAppmate } from "../helpers";

export default class extends Controller {
  static targets = ["hoverImage", "mainImage"];
  static values = {
    variant: Number,
    product: Number,
    handle: String,
  };

  initialize() {
    if (this.wishlistController) {
      this.handleWishlistState();
    }
  }

  getImageUrl = (image) => image.split("?")[0];

  // Handle visibilty of image when hovering
  showVariantImage(e) {
    const hoverImage = e?.params?.image || null;
    const baseImage = e?.params?.baseImage || null;

    if (
      hoverImage &&
      this.getImageUrl(hoverImage) !== this.getImageUrl(baseImage)
    ) {
      this.hoverImageTarget.src = hoverImage;
      this.hoverImageTarget.classList.remove(
        "product-card__swatch-image--hidden"
      );

      this.mainImageTarget.classList.add("product-card__main-image--hidden");
    }
  }

  hideVariantImage(e) {
    const hoverImage = e?.params?.image || null;
    const baseImage = e?.params?.baseImage || null;

    if (
      hoverImage &&
      this.getImageUrl(hoverImage) !== this.getImageUrl(baseImage)
    ) {
      this.hoverImageTarget.classList.add("product-card__swatch-image--hidden");
      this.mainImageTarget.classList.remove("product-card__main-image--hidden");
    }
  }

  handleWishlistState() {
    const { products } = this.wishlistController;
    if (products) {
      const variant = this.element.querySelector("[data-variant-id]");
      const hasVariant = products.find(
        (product) => product.selected_variant_id == this.variantValue
      );

      if (hasVariant) {
        variant.innerHTML = `<button data-action="wishlist#toggle" type="button" class="wk-button-product" title="Remove from Wishlist" data-wishlist-product-param="${this.productValue}" data-wishlist-variant-param="${this.variantValue}" data-wishlist-state-param="remove" data-wishlist-handle-param="${this.handleValue}">
          <span class="wk-label hidden">Remove from Wishlist</span>
          <div class="wk-icon">

          <svg version="1.1" xmlns="https://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64">
            <path d="M47.199 4c-6.727 0-12.516 5.472-15.198 11.188-2.684-5.715-8.474-11.188-15.201-11.188-9.274 0-16.8 7.527-16.8 16.802 0 18.865 19.031 23.812 32.001 42.464 12.26-18.536 31.999-24.2 31.999-42.464 0-9.274-7.527-16.802-16.801-16.802z" fill="#000"></path>
          </svg>

          </div>
        </button>`;
      } else {
        variant.innerHTML = `
        <button data-action="wishlist#toggle" type="button" class="wk-button-product" title="Add to Wishlist" data-wishlist-product-param="${this.productValue}" data-wishlist-variant-param="${this.variantValue}" data-wishlist-state-param="add" data-wishlist-handle-param="${this.handleValue}">
        <span class="wk-label hidden">Add to wishlist</span>
        <div class="wk-icon">

        <svg version="1.1" xmlns="https://www.w3.org/2000/svg" width="64px" height="60.833px" viewBox="0 0 64 60.833">
          <path stroke="#000" stroke-width="5" stroke-miterlimit="10" fill-opacity="0" d="M45.684,2.654c-6.057,0-11.27,4.927-13.684,10.073 c-2.417-5.145-7.63-10.073-13.687-10.073c-8.349,0-15.125,6.776-15.125,15.127c0,16.983,17.134,21.438,28.812,38.231 c11.038-16.688,28.811-21.787,28.811-38.231C60.811,9.431,54.033,2.654,45.684,2.654z"></path>
        </svg>

        </div>
      </button>`;
      }
    }
  }

  get wishlistController() {
    return this.application.controllers.find((controller) => {
      return controller.context.identifier === "wishlist";
    });
  }
}
